import { createSlice } from '@reduxjs/toolkit';
import { set } from 'date-fns';
const initialState = {
  openSidebar: false,
  selectedFeatures: [],
  selectedUsers: [],
  modules: {},
  userProfile: null,
  grantButtonsDisabled: true,
  revokeButtonsDisabled: true,
};

export const userSlice = createSlice({
  name: 'user',
  initialState: initialState,
  reducers: {
    setSidebar: (state, action) => {
      const { value } = action.payload;
      state.openSidebar = value;
    },
    setModules: (state, action) => {
      const modules = action.payload;

      for (let i = 0; i < modules.length; i++) {
        let featureArray = modules[i].features.map((feat) => ({ feature: feat, checked: feat.checked || false }));
        state.modules[modules[i].name] = featureArray;
      }
    },
    setSelectedFeatures: (state, action) => {
      const { module, featId, type, signal } = action.payload;
      if (signal && state.userProfile) {
        if (signal !== state.userProfile[3] || signal === true) {
          state.selectedFeatures = [];
        }
      } else {
        if (type === 'add') {
          state.selectedFeatures.push(featId);
          state.modules[module] = state.modules[module].map((feat) =>
            feat.feature.permission === featId ? { ...feat, checked: true } : feat
          );
        }
        if (type === 'remove') {
          state.selectedFeatures = state.selectedFeatures.filter((feature) => feature !== featId);
          state.modules[module] = state.modules[module].map((feat) =>
            feat.feature.permission === featId ? { ...feat, checked: false } : feat
          );
        }
      }
    },
    setSelectedUsers: (state, action) => {
      const users = action.payload;
      state.selectedUsers = users;
    },
    setUserProfile: (state, action) => {
      state.userProfile = action.payload;
    },
    setGrantButtonDisabled: (state, action) => {
      state.grantButtonsDisabled = action.payload;
    },
    setRevokeButtonDisabled: (state, action) => {
      state.revokeButtonsDisabled = action.payload;
    },
  },
  extraReducers(builder) {},
});

export const selectSidebarOpen = (state) => {
  return state.user.openSidebar;
};
export const selectModules = (state) => {
  return state.user.modules;
};
export const selectSelectedFeatures = (state) => {
  return state.user.selectedFeatures;
};
export const selectSelectedUsers = (state) => {
  return state.user.selectedUsers;
};
export const selectUserProfile = (state) => state.user.userProfile;
export const selectGrantButtonsDisabled = (state) => state.user.grantButtonsDisabled;
export const selectRevokeButtonsDisabled = (state) => state.user.revokeButtonsDisabled;

export const { setSidebar, setSelectedFeatures, setModules, setSelectedUsers, setUserProfile, setGrantButtonDisabled, setRevokeButtonDisabled } = userSlice.actions;
export default userSlice.reducer;
